import { render, staticRenderFns } from "./BeforeDocumentCreate.vue?vue&type=template&id=44658aa2&"
import script from "./BeforeDocumentCreate.vue?vue&type=script&lang=js&"
export * from "./BeforeDocumentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports